import { render, staticRenderFns } from "./DropOff.vue?vue&type=template&id=2a534b4c&lang=pug&"
import script from "./DropOff.vue?vue&type=script&lang=js&"
export * from "./DropOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports